import { render, staticRenderFns } from "./LoadingWheel.vue?vue&type=template&id=07b9d1bc&scoped=true&"
import script from "./LoadingWheel.vue?vue&type=script&lang=js&"
export * from "./LoadingWheel.vue?vue&type=script&lang=js&"
import style0 from "./LoadingWheel.vue?vue&type=style&index=0&id=07b9d1bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b9d1bc",
  null
  
)

export default component.exports